export const colors = {

    white: '#ffffff',


    darkestBlue: '#09224a',
    darkerBlue: '#032e74',
    darkBlue: '#033381',
    prettyBlue: '#0949b2',

    actionGreen1: '#12ffcd',
    actionGreen2: '#05efbe',
    actionGreen3: '#05e1b3',
    actionPurple: '#b517ec',

    titleGreen: '#12ffcd',
    titleBlue: '#11f5ff',
};
